import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Sticky {
  constructor(el) {
 
    this.el = el;

    this.elms = {
      main: (window.innerWidth < 1024) ? this.el.querySelector("[data-sticky-mobile]") : this.el.querySelector("[data-sticky-desktop]"),
    };

    if (this.elms.main) {
      this.init();
    }

		this.limit = this.el.getBoundingClientRect().top + this.el.getBoundingClientRect().height + window.scrollY + 100;

    this.state = false;
    this.lastDirection = false;
  }

  init() {
    ScrollTrigger.create({
      start: "top top",
      end: "bottom top",
      onUpdate: (self) => {

        const headerBottom = this.elms.main;
        const headerBottomHeight = headerBottom.getBoundingClientRect().height;
      
        if ( window.scrollY > this.limit && window.scrollY < 400) {

					if( this.state !== 'ready' ){  
						gsap.set(headerBottom, { position: "fixed", top: headerBottomHeight * -1 });
						gsap.set(this.el, { paddingBottom: headerBottomHeight });
						this.state = "ready";
					}

        } else if (window.scrollY > 400) {

          
          if( this.state !== 'sticky' ){  
            gsap.set(headerBottom, { position: "fixed" });
            gsap.set(this.el, { paddingBottom: headerBottomHeight });
            headerBottom.classList.add("is-sticky");
            document.body.classList.add("is-sticky");
            this.state = "sticky";
          }
           
          if( this.lastDirection !== self.direction ){
						if (self.direction === -1) { 
							gsap.set(headerBottom, { top: 0 });
						} else { 
							gsap.set(headerBottom, { top: headerBottomHeight * -1  });
						} 
					}

        } else {

					if( this.state !== 'initial' ){   
						gsap.set(headerBottom, { position: "initial", top: 0 });
						gsap.set(this.el, { paddingBottom: 0 });
						headerBottom.classList.remove("is-sticky"); 
            document.body.classList.remove("is-sticky");
						this.state = "initial";
					} 

        }

				this.setDirection(self.direction);

      },
    });
  }

  setDirection(direction) {
    document.body.classList.remove("is-scroll-down");
    document.body.classList.remove("is-scroll-up"); 
    if (direction === -1) { 
      document.body.classList.add("is-scroll-up"); 
    } else {
      document.body.classList.add("is-scroll-down"); 
    }

		this.lastDirection = direction;
  }
}
